module.exports = __webpack_public_path__ + "img/inews24.b8978a2.jpg";